import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import Flex from "../../../../components/Flex/Flex";
import useSearchInput from "../../../ui/hooks/useSearchInput";

import CreateDistributionChannelButton from "../../../distribution/components/CreateDistributionChannelForm/CreateDistributionChannelButton";
import DistributionChannelsCollectionDataTable from "../../../distribution/components/DistributionChannelsCollectionDataTable/DistributionChannelsCollectionDataTable";

export default function SuperAdminDistributionChannelsView() {
	const { t } = useTranslation();

	const [searchInput, searchQuery] = useSearchInput();

	return (
		<>
			<Flex gap={10} wrap style={{ marginBottom: 15 }}>
				<div>
					<Header as="h2">{t("distributionChannels", "Distribution channels")}</Header>
				</div>

				<div style={{ whiteSpace: "nowrap" }}>
					<Flex gap={10} justifyContent="flex-start">
						{searchInput}

						<CreateDistributionChannelButton primary />
					</Flex>
				</div>
			</Flex>

			<DistributionChannelsCollectionDataTable searchQuery={searchQuery} />
		</>
	);
}
